import Link from "next/link";

const Error: React.FC<{ errorTitle?: string; errorMessage?: string }> = ({
  errorTitle,
  errorMessage,
}) => {
  return (
    <div className="flex min-h-full flex-col pb-12 pt-16">
      <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="text-center">
            <h1 className="mt-2 text-4xl font-extrabold tracking-tight text-primary-100 sm:text-5xl">
              {errorTitle ??
                "An error occurred while processing your request. Please try again.."}
            </h1>
            <p className="mt-2 text-base text-light-300">
              {errorMessage ?? "Please try again soon."}
            </p>
            <div className="mt-6">
              <Link
                href="/"
                className="text-base font-medium text-primary-100 hover:text-primary-150"
              >
                Go back home<span aria-hidden="true"> &rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <footer className="mx-auto w-full max-w-7xl flex-shrink-0 px-4 sm:px-6 lg:px-8">
        <nav className="flex justify-center space-x-4">
          <Link
            href="https://rfox.zendesk.com"
            rel="noopener noreferrer"
            target="_blank"
            className="text-sm font-medium text-light-300 hover:text-light-350"
          >
            Contact Support
          </Link>
          <span
            className="inline-block border-l border-light-300"
            aria-hidden="true"
          />
          <Link
            href="https://discord.com/invite/rfox"
            rel="noopener noreferrer"
            target="_blank"
            className="text-sm font-medium text-light-300 hover:text-light-350"
          >
            Discord
          </Link>
        </nav>
      </footer>
    </div>
  );
};

export default Error;
